import { amountValidation, ColorOptions, required, Spacer, Text, TextInputNew } from '@jfs/ui-new'
import { isEmpty } from '@jfs/utils'
import * as Yup from 'yup'
import { DropdownOptimised } from '../../comps/DropdownNew'
import { TextInputWithDelete } from '../../comps/TextInputWithDelete'
import { Colors } from '../../util/util'
import { DateTimePicker } from './DateTimePicker'
import { RuleConfig } from './RuleConfig'

const NO_COST_EMI = 'No Cost EMI'
const percentValidation = Yup.string()
  .trim()
  .required('Required')
  .min(1, 'Please enter a number')
  .matches(/^100(\.0{1,2})?$|^([1-9]([0-9])?|0)(\.[0-9]{1,2})?$/, 'Please enter correct percentage.')

const startSchema = Yup.number()
  .min(new Date().getTime(), "Start date can't be before Current date")
  .required('Required!')
const endSchema = Yup.number().min(Yup.ref('startDate'), "End date can't be before Start date").required('Required!')
const editEndSchema = Yup.number().min(new Date().getTime(), "End date can't be before Current date").required('Required!')

const textinputStyle = {
  type: 'body12',
  borderColor: Colors.BORDER_LIGHT_BLUE as ColorOptions,
  focusBorderColor: Colors.BORDER_LIGHT_BLUE as ColorOptions,
  labelPaddingBottom: 8,
  borderRadius: 4,
  labelFontFamily: 'jiotype-medium',
  labelColor: Colors.LABEL_GREY as ColorOptions,
  fontFamily: 'jiotype-medium',
  placeholderTextColor: Colors.LABEL_GREY as ColorOptions,
  color: Colors.FONT_BLACK as ColorOptions,
  labelFontSize: 12,
  fontSize: 12,
  paddingHorizontal: 8,
}

export const CreaateCampaignForm: any = (getInstruments: any, percentageIcon: any, rupee: any, lockComp: any, id: any, rightComp: any, updatePaymentMode: any, paymentMode: any, isDuplicate: boolean) => [
  {
    actionTitle: 'Proceed',
    key: 'basicInfo',
    formItems: [
      {
        horizontalComps: [
          {
            fieldName: 'label',
            ComponentName: Text,
            title: 'Campaign Details',
            color: '#000000DE' as ColorOptions,
            fontFamily: 'jiotype-bold',
            fontSize: 14,
            testID: 'label',
            flex: 0.15,
          },
          {
            fieldName: 'campaignId',
            ComponentName: TextInputNew,
            label: 'Campaign ID *',
            placeholder: 'Campaign ID',
            validationSchema: required,
            editable: isDuplicate || isEmpty(id),
            ...textinputStyle,
            paddingVertical: 8,
            testID: 'campaignId',
            rightComponent: isDuplicate ? undefined: lockComp,
            flex: 0.425,
          },
          {
            fieldName: 'title',
            ComponentName: TextInputNew,
            label: 'Campaign Title *',
            placeholder: 'Campaign Title',
            editable:isDuplicate|| isEmpty(id),
            validationSchema: required,
            ...textinputStyle,
            paddingVertical: 8,
            testID: 'campaignTitle',
            rightComponent: isDuplicate ? undefined: lockComp,
            flex: 0.425,
          },
        ],
        horizontalSpacing: 8,
      },
      {
        horizontalComps: [
          {
            fieldName: 'spacer2',
            label: 'spacer2',
            ComponentName: Spacer,
            direction: 'vertical',
            size: 40,
            flex: 0.15,
          },
          {
            fieldName: 'startDate',
            ComponentName: DateTimePicker,
            label: 'Start Date *',
            placeholder: 'Start Date',
            editable: isDuplicate ?true:false,
            validationSchema: id &&!isDuplicate? undefined : startSchema,
            paddingVertical: 8,
            testID: 'startDate',
            flex: 0.425,
            rightComponent: isDuplicate?undefined:lockComp,
            disabled: !isEmpty(id) && !isDuplicate,
     
          },
          {
            fieldName: 'endDate',
            ComponentName: DateTimePicker,
            label: 'End Date *',
            placeholder: 'End Date',
            editable: isDuplicate ?true:false,
            validationSchema: id ? editEndSchema : endSchema,
            paddingVertical: 8,
            testID: 'endDate',
            flex: 0.425,
            rightComponent: isDuplicate?undefined:lockComp,
          },
        ],
        horizontalSpacing: 8,
      },
      {
        horizontalComps: [
          {
            fieldName: 'spacer3',
            testID: 'spacer3',
            ComponentName: Spacer,
            direction: 'vertical',
            size: 40,
            flex: 0.15,
          },
          {
            fieldName: 'description',
            ComponentName: TextInputNew,
            label: 'Description *',
            placeholder: 'Description',
            editable: true,
            validationSchema: required,
            ...textinputStyle,
            paddingVertical: 8,
            testID: 'description',
            flex: 0.85,
          },
        ],
        horizontalSpacing: 8,
      },
      {
        horizontalComps: [
          {
            fieldName: 'spacer4',
            testID: 'spacer4',
            ComponentName: Spacer,
            direction: 'vertical',
            size: 40,
            flex: 0.15,
          },
          {
            fieldName: 'tnc',
            ComponentName: TextInputNew,
            label: 'Terms & Conditions *',
            placeholder: 'Terms & Conditions',
            editable: true,
            validationSchema: required,
            ...textinputStyle,
            paddingVertical: 8,
            testID: 'tnc',
            flex: 0.85,
          },
        ],
        horizontalSpacing: 8,
      },
      {
        fieldName: 'spacer5',
        testID: 'spacer5',
        ComponentName: Spacer,
        direction: 'vertical',
        size: 8,
        flex: 1,
      },
      {
        horizontalComps: [
          {
            fieldName: 'label2',
            testID: 'label2',
            ComponentName: Text,
            title: 'Rules Configuration',
            color: '#000000DE' as ColorOptions,
            fontFamily: 'jiotype-bold',
            fontSize: 14,
            flex: 0.15,
          },
          {
            fieldName: 'ruleConfig',
            testID: 'ruleConfig',
            ComponentName: RuleConfig,
            disabled: !isEmpty(id)&& !isDuplicate,
            updatePaymentMode: updatePaymentMode,
            flex: 0.85,
          },
        ],
      },
      {
        fieldName: 'spacer6',
        testID: 'spacer6',
        ComponentName: Spacer,
        direction: 'vertical',
        size: 8,
        flex: 1,
      },
      {
        horizontalComps: [
          {
            fieldName: 'label3',
            testID: 'label3',
            ComponentName: Text,
            title: 'Rewards',
            color: '#000000DE' as ColorOptions,
            fontFamily: 'jiotype-bold',
            fontSize: 14,
            flex: 0.15,
          },
          {
            fieldName: 'offerType',
            ComponentName: DropdownOptimised,
            title: 'Offer Type',
            label: 'Select Offer Type *',
            placeHolder: 'Select Offer Type',
            validationSchema: (!isEmpty(id)&&!isDuplicate) || paymentMode === NO_COST_EMI ? undefined : required,
            data: getInstruments('rewardType') ?? [],
            testID: 'offerType',
            flex: 0.425,
            borderColor: Colors.BORDER_LIGHT_BLUE as ColorOptions,
            labelColor: Colors.LABEL_GREY as ColorOptions,
            labelFontFamily: 'jiotype-medium',
            labelPaddingBottom: 4,
            fontWeight: '500',
            titleColor: Colors.FONT_GREY as ColorOptions,
            disabled: (!isEmpty(id)&&!isDuplicate )|| paymentMode === NO_COST_EMI,
            disabledBg: 'WHITE',
          },
          {
            fieldName: 'discountType',
            ComponentName: DropdownOptimised,
            label: 'Discount Type *',
            title: 'Discount Type',
            placeHolder: 'Discount Type',
            validationSchema: (!isEmpty(id)  &&!isDuplicate )|| paymentMode === NO_COST_EMI ? undefined : required,
            data: getInstruments('unitType') ?? [],
            testID: 'discountValue',
            fontWeight: '500',
            flex: 0.425,
            labelPaddingBottom: 4,
            borderColor: Colors.BORDER_LIGHT_BLUE as ColorOptions,
            labelColor: Colors.LABEL_GREY as ColorOptions,
            labelFontFamily: 'jiotype-medium',
            titleColor: Colors.FONT_GREY as ColorOptions,
            disabled: (!isEmpty(id)&&!isDuplicate ) || paymentMode === NO_COST_EMI,
            disabledBg: 'WHITE',
          },
        ],
      },
      {
        horizontalComps: [
          {
            fieldName: 'spacer7',
            testID: 'spacer7',
            ComponentName: Spacer,
            direction: 'vertical',
            size: 40,
            flex: 0.15,
          },
          {
            fieldName: 'rewardPercentage',
            ComponentName: TextInputNew,
            label: 'Percentage *',
            placeholder: 'Value',
            editable: (isEmpty(id) ||isDuplicate )&& paymentMode !== NO_COST_EMI,
            rightComponent: (isEmpty(id)||isDuplicate ) && paymentMode !== NO_COST_EMI ? percentageIcon : rightComp,
            validationSchema: (isEmpty(id)||isDuplicate) && paymentMode !== NO_COST_EMI ? percentValidation : undefined,
            ...textinputStyle,
            paddingVertical: 8,
            testID: 'value',
            dependency: ['discountType', 'Percentage'],
            flex: 0.425,
          },
          {
            fieldName: 'rewardAmount',
            ComponentName: TextInputNew,
            label: 'Amount *',
            placeholder: 'Value',
            editable: (isEmpty(id)|| isDuplicate) && paymentMode !== NO_COST_EMI,
            rightComponent: (isEmpty(id)||isDuplicate ) && paymentMode !== NO_COST_EMI ? undefined : rightComp,
            validationSchema: (isEmpty(id) ||isDuplicate )&& paymentMode !== NO_COST_EMI ? amountValidation : undefined,
            ...textinputStyle,
            paddingVertical: 8,
            testID: 'value-amount',
            dependency: ['discountType', 'Fixed'],
            flex: 0.425,
          },
          {
            fieldName: 'maxCashback',
            ComponentName: TextInputNew,
            label: 'Maximum Discount/Cashback *',
            placeholder: 'Maximum Discount/Cashback',
            editable: (isEmpty(id)||isDuplicate) && paymentMode !== NO_COST_EMI,
            rightComponent: (isEmpty(id)||isDuplicate  ) && paymentMode !== NO_COST_EMI ? rupee : rightComp,
            validationSchema:  (isEmpty(id) ||isDuplicate ) && paymentMode !== NO_COST_EMI ? amountValidation : undefined,
            ...textinputStyle,
            paddingVertical: 8,
            testID: 'maxCashback',
            flex: 0.425,
          },
        ],
      },
      {
        horizontalComps: [
          {
            fieldName: 'spacer8',
            testID: 'spacer8',
            ComponentName: Spacer,
            direction: 'vertical',
            size: 40,
            flex: 0.15,
          },
          {
            fieldName: 'linkedCampaignId',
            ComponentName: TextInputWithDelete,
            label: 'Linked Campaign Id',
            placeholder: 'Linked Campaign Id',
            title: 'Linked Campaign Id',
            editable: true,
            ...textinputStyle,
            testID: 'linkedCampaignId',
            flex: 0.425,
            setValuesOnFieldNameObject: false,
            bgColor: Colors.BG_BLUE_LIGHT as ColorOptions,
            color: Colors.BG_BLUE as ColorOptions,
            textWidth: 150,
            borderRadius: 40,
            hideDelete: true,
            isLinkedId: true,
            hide: paymentMode !== 'No Cost EMI' && paymentMode !== 'Card',
          },
        ],
      },
      {
        fieldName: 'spacer9',
        testID: 'spacer9',
        ComponentName: Spacer,
        direction: 'vertical',
        size: 20,
      },
    ],
    onSubmit: async () => {
      return ''
    },
  },
]
